<template>
  <UserLayout>
    <div
      class="md:px-0 lg:ml-20 md:mt-16 mt-32 md:flex bg-gray-lightest mx-auto"
    >
      <div class="md:w-4/12 md:mr-4">
        <section class="mb-4 grid md:hidden">
          <img
            class="object-cover h-48 w-full rounded"
            :src="
              baseUrlSrc(
                trainerDetail &&
                  trainerDetail.profile &&
                  trainerDetail.profile.banner_url
              )
            "
            alt=""
            @error="defaultImage"
          />
        </section>
        <section class="flex md:grid md:px-3 px-1 pt-3 md:pt-0">
          <div class="flex justify-center md:mt-4 mt-0">
            <div
              v-if="
                trainerDetail.profile && trainerDetail.profile.thumbnail_url
              "
            >
              <Avatar
                :classStr="'object-cover md:h-40 md:w-40 h-32 w-32'"
                :src="baseUrlSrc(trainerDetail.profile.thumbnail_url)"
              />
            </div>
            <div v-else>
              <Avatar :classStr="'md:h-40 md:w-40 h-32 w-32'" src="" />
            </div>
          </div>
          <div class="text-start md:text-center px-4 py-4">
            <div>
              <div class="flex md:justify-center justify-start items-center">
                <h5 class="capitalize text-lg mr-2">
                  {{ trainerDetail.profile && trainerDetail.profile.f_name }}
                  {{ trainerDetail.profile && trainerDetail.profile.l_name }}
                </h5>
                <div v-if="getToken()" class="md:mt-0 mt-1">
                  <button
                    @click="handleUserFollowTrainer(0)"
                    v-if="trainerDetail.is_following"
                  >
                    <HeartFill :classStr="'h-6 w-6'" />
                  </button>
                  <button @click="handleUserFollowTrainer(1)" v-else>
                    <Heart :classStr="'h-6 w-6'" />
                  </button>
                </div>
              </div>
              <p
                class="text-sm text-gray-800"
                v-if="
                  trainerDetail &&
                  trainerDetail.profile &&
                  trainerDetail.profile.dob
                "
              >
                {{ handleProfileDob(trainerDetail.profile.dob) }} Years
              </p>
            </div>
            <span class="text-md text-gray-dark"
              >{{ trainerDetail.followers_count }} Followers</span
            >
            <div class="flex mt-4 items-center flex-wrap md:justify-center">
              <div
                v-if="trainerDetail.profile && trainerDetail.profile.insta_link"
              >
                <a
                  :href="handleProfileUrl(trainerDetail.profile.insta_link)"
                  target="_blank"
                >
                  <InstagramIcon></InstagramIcon>
                </a>
              </div>
              <div
                v-if="trainerDetail.profile && trainerDetail.profile.fb_link"
              >
                <a
                  :href="handleProfileUrl(trainerDetail.profile.fb_link)"
                  target="_blank"
                >
                  <FaceBookIcon></FaceBookIcon>
                </a>
              </div>
            </div>
            <button
              @click="tipModalHandler"
              class="h-8 px-5 m-2 text-white transition-colors duration-150 bg-green-light rounded-lg focus:shadow-outline hover:bg-green-dark"
            >
              Tip Trainer
            </button>
            <TipPaymentModal
              v-if="isTipPaymentModalOpen"
              callerComp="UserTrainer"
              :tipModalHandler="tipModalHandler"
              :details="trainerDetail && trainerDetail.profile"
            ></TipPaymentModal>
          </div>
        </section>
        <div class="ring-gray-500 ring-1 mt-3 md:mt-0 md:ml-4 md:mr-4"></div>

        <section class="mt-6 md:px-4">
          <ul class="flex justify-around md:grid md:justify-start">
            <router-link
              :to="{
                name: 'UserTrainerAbout',
                params: { trainer_id: $route.params.trainer_id },
              }"
              class="rounded-lg hover:bg-gray-light hover:bg-opacity-25 focus:bg-opacity-25 my-1 text-gray-light"
              active-class="bg-opacity-25 text-gray-dark "
            >
              <li class="md:py-2 md:px-4 md:w-64 py-1 px-2">About</li>
            </router-link>
            <router-link
              :to="{ name: 'UserTrainerReview' }"
              class="rounded-lg hover:bg-gray-light hover:bg-opacity-25 focus:bg-opacity-25 my-1 text-gray-light"
              active-class="bg-opacity-25 text-gray-dark"
            >
              <li class="md:py-2 md:px-4 md:w-64 py-1 px-2">Reviews</li>
            </router-link>
            <!-- <router-link
              :to="{ name: 'UserTrainerPost' }"
              class="rounded-lg hover:bg-gray-light hover:bg-opacity-25 focus:bg-opacity-25 my-1 text-gray-light"
              active-class="bg-opacity-25 text-gray-dark"
            >
              <li class="md:py-2 md:px-4 md:w-64 py-1 px-2">Post</li>
            </router-link>
            <router-link
              :to="{ name: 'UserTrainerStore' }"
              class="rounded-lg hover:bg-gray-light hover:bg-opacity-25 focus:bg-opacity-25 my-1 text-gray-light"
              active-class="bg-opacity-25 text-gray-dark"
            >
              <li class="md:py-2 md:px-4 md:w-64 py-1 px-2">Store</li>
            </router-link> -->
            <router-link
              :to="{ name: 'UserTrainerActive' }"
              class="rounded-lg hover:bg-gray-light hover:bg-opacity-25 focus:bg-opacity-25 my-1 text-gray-light"
              active-class="bg-opacity-25 text-gray-dark"
            >
              <li class="md:py-2 md:px-4 md:w-64 py-1 px-2">Active</li>
            </router-link>
          </ul>
        </section>
      </div>

      <div class="md:8/12 w-full">
        <router-view
          :profile="trainerDetail && trainerDetail.profile"
          :reviews="trainerDetail && trainerDetail.reviews"
          :sessions_count="trainerDetail && trainerDetail.sessions_count"
          :course_count="trainerDetail && trainerDetail.course_count"
        ></router-view>
      </div>
    </div>
  </UserLayout>
</template>

<script>
import { Heart, HeartFill, InstagramIcon, FaceBookIcon } from "@/components/icons";
import UserLayout from "@/components/layouts/UserLayout";
import { Avatar } from "@/components/t-components";
import { mapGetters, mapActions } from "vuex";
import TipPaymentModal from "@/components/t-components/TipPaymentModal";

export default {
  name: "UserTrainer",
  components: {
    Heart,
    HeartFill,
    UserLayout,
    Avatar,
    InstagramIcon,
    FaceBookIcon,
    TipPaymentModal,
  },
  data() {
    return {
      isTipPaymentModalOpen: false
    };
  },
  computed: {
    ...mapGetters(["trainerDetail"]),
  },
  methods: {
    ...mapActions(["getTrainerDetail", "userFollowTrainer"]),

    async handleUserFollowTrainer(val) {
      const data = {
        trainer_id: this.$route.params.trainer_id,
        is_follow: val,
      };
      await this.userFollowTrainer(data);
      await this.getTrainerDetail(this.$route.params.trainer_id);
    },
    tipModalHandler () {
      if (this.getToken()) {
        this.isTipPaymentModalOpen = !this.isTipPaymentModalOpen
      } else {
        this.$store.commit('setAuthModalActive', true)
      }
    }
  },
  async created() {
    await this.getTrainerDetail(this.$route.params.trainer_id);
  },
};
</script>